import { BaseUnknownRecordType, ValueOf } from "@/types/basic";

export type FilterPaginationType = {
  page?: number | string;
  perPage?: number | string;
};

export const SORT_BASE_KEYS = {
  popularity: "popularity",
  name: "name",
} as const;

export const SORT_ORDER_KEYS = {
  asc: "ASC",
  desc: "DESC",
} as const;

export const SORT_PARAM_KEYS = {
  sortBy: "sortBy",
  order: "order",
};
export type SortBaseType = {
  sortBy?: ValueOf<typeof SORT_BASE_KEYS>;
};

export type SortOrderType = {
  order?: ValueOf<typeof SORT_ORDER_KEYS>;
};

export type SortParamsType = SortBaseType & SortOrderType;

export type FilterParamsType = FilterPaginationType & SortParamsType;

export type FilterStaticQueryParamsType<
  T extends Record<string, unknown> | void = Record<string, unknown>,
> = FilterParamsType & BaseUnknownRecordType & T;
